import _ from "lodash";
import * as nl from "./locales/nl.json";
import * as overrides from "./locales/nl.overrides.json";
const numberFormats = { "nl-NL": {
	currency: {
		style: "currency",
		currency: "EUR"
	},
	decimal: {
		style: "decimal",
		minimumFractionDigits: 2,
		maximumFractionDigits: 2
	},
	percent: {
		style: "percent",
		useGrouping: false
	}
} };
const datetimeFormats = { "nl-NL": {
	short: {
		year: "numeric",
		month: "short",
		day: "numeric"
	},
	long: {
		weekday: "long",
		year: "numeric",
		month: "long",
		day: "numeric"
	}
} };
export default () => ({
	locale: "nl-NL",
	fallbackLocale: "nl-NL",
	legacy: false,
	messages: { "nl-NL": _.merge(nl, overrides) },
	numberFormats,
	datetimeFormats
});
